{
  "root": "src/app/ms-teams/build/manifest",
  "manifestMsTeams": "src/app/ms-teams/build/manifest/manifest.json",
  "availableLocales": [
    "ar",
    "cs",
    "de",
    "el",
    "en",
    "en-gb",
    "es",
    "es-es",
    "fr",
    "fr-ca",
    "he",
    "hu",
    "id",
    "it",
    "ja",
    "ko",
    "nl",
    "pl",
    "pt",
    "pt-br",
    "pt-pt",
    "ro",
    "ru",
    "sv",
    "th",
    "tr",
    "vi",
    "zh",
    "zh-cn",
    "zh-tw"
  ],
  "distPath": "src/app/ms-teams/build/dist/",
  "msTeamsDistPath": "src/app/ms-teams/build/dist/artifacts",
  "manifestValidDomains": [],
  "manifestLocalizations": "src/app/ms-teams/build/manifest/localizations.json",
  "manifestTranslationMappings": "src/app/ms-teams/build/manifest/translationMappings.json",
  "environment": {
    "local": {
      "appId": "e5e829df-1793-40fb-806a-8f9ce70a8e14",
      "webAppId": "e5e829df-1793-40fb-806a-8f9ce70a8e14",
      "name": "Degreed (Local)",
      "baseUrl": "https://localhost:44300"
    },
    "dev": {
      "appId": "f7cf42e4-8417-403f-aa1d-2422ddd7e79c",
      "webAppId": "f7cf42e4-8417-403f-aa1d-2422ddd7e79c",
      "name": "Degreed Gateway (Local)",
      "baseUrl": "https://gateway.dev.degreed.dev"
    },
    "staging": {
      "appId": "b8c12251-5047-4fbd-864d-a09a7ad64ee7",
      "webAppId": "c1c5911c-f115-4b92-a5da-c31777d1f8c3",
      "name": "Degreed Gateway (Staging)",
      "baseUrl": "https://gateway.staging.degreed.dev"
    },
    "release": {
      "appId": "bae7af95-c513-4107-929b-572388b84131",
      "webAppId": "98bf9644-5aaa-4e2f-a868-ff589af24775",
      "name": "Degreed Gateway (Release)",
      "baseUrl": "https://gateway.release.degreed.dev"
    },
    "beta": {
      "appId": "41da813e-70d6-4024-9a27-343b76233a98",
      "webAppId": "90a5430e-6299-40df-8d19-a95d2d8fc0e8",
      "name": "Degreed Gateway (Beta)",
      "baseUrl": "https://gateway.beta.degreed.app"
    },
    "prod": {
      "appId": "3509c881-ce89-4922-b7e3-e92151b5df9c",
      "webAppId": "5a1b5edc-a574-4ab2-b2eb-9d49ca4f3914",
      "name": "Degreed",
      "baseUrl": "https://gateway.degreed.app"
    }
  }
}